import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import { Button } from "@mui/material";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  listRecordCategories,
  deleteCategory,
} from "../actions/VivoFinanceActions";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import ConfirmDialog from "../components/ConfirmDialog";
import styles from "assets/jss/vivoleo-react-kit/views/componentsSections/addRecordScreenStyle";
import { CATEGORY_DELETE_RESET } from "../constants/financeConstants";
import Notification from "../components/Notification";

const useStyles = makeStyles(styles);

export default function ListCategories(props) {
  const classes = useStyles();
  const recordCategoryList = useSelector((state) => state.recordCategoryList);
  const { loading, error, summary } = recordCategoryList;

  console.log("categories:" + summary);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const categoryDelete = useSelector((state) => state.categoryDelete);
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = categoryDelete;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: CATEGORY_DELETE_RESET });
    dispatch(listRecordCategories());
  }, [dispatch, successDelete]);

  const onDelete = (category) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    // if (window.confirm('Are you sure to delete?')) {
    dispatch(deleteCategory(category._id));
    setNotify({
      isOpen: true,
      message: "Category Deleted Successfully",
      type: "success",
    });

    // }
  };
  return (
    <div>
      <h1>Category List</h1>
      <div>
        <Button className={classes.btnColor}>
          <Link to="/addcategory">Add Category</Link>
        </Button>
      </div>

      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <>
          <ul>
            <li>
              <div className="summary-title color2">
                <span>
                  <i className="fa fa-shopping-cart" /> Total Records
                </span>
              </div>
              <div className="summary-body">
                {summary.categorySum[0]
                  ? summary.categorySum[0].numCategories
                  : 0}
              </div>
            </li>
          </ul>
          <table className="table">
            <thead>
              <tr>
                <th>Category ID</th>
                <th>Category Name</th>
                <th>other information</th>
              </tr>
            </thead>

            <tbody>
              {summary.categories.length === 0 ? (
                <MessageBox>No Record</MessageBox>
              ) : (
                summary.categories.map((category) => (
                  <tr key={category._id}>
                    <td>{category._id}</td>
                    <td>{category.category}</td>
                    <td>{category.otherinfo}</td>
                    <td>
                      <button
                        type="button"
                        className="small"
                        onClick={() => {
                          props.history.push(`/catrecord/${category._id}`);
                        }}
                      >
                        Details
                      </button>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="small"
                        onClick={() => {
                          setConfirmDialog({
                            isOpen: true,
                            title: "Are you sure to delete the Category?",
                            subTitle:
                              "You can't UNDO this operation once you click YES!",
                            onConfirm: () => {
                              onDelete(category);
                            },
                          });
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </>
      )}
      <Notification notify={notify} setNotify={setNotify}></Notification>
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </div>
  );
}
